import { Modal } from "antd";
import {
  ForwardedRef,
  forwardRef,
  useImperativeHandle,
  useState,
} from "react";
import styled from "styled-components";
import useLotesImpresionAPI from "../../lotes-impresion/useLotesImpresionAPI";

const StyledIframe = styled.iframe`
  width: 100%;
  height: 60vh;
  background: url("https://i.gifer.com/7plQ.gif") center center no-repeat;
`;

const StyledModal = styled(Modal)`
  width: 90% !important;
  max-width: 1200px !important;
`;

const ErrorMessage = styled.div`
  text-align: center;
  margin-top: 20px;
  font-weight: bold;
`;

export interface ActaPreviewRef {
  setOpen: (value: boolean) => any;
  setInfraccionId: (value: string) => any;
  setInfraccionEstado: (value: string) => any;
  setTitularId: (value: number) => any;
  setConfiguracionProduccionId: (value: string) => any;
}

const ActaPreview = (props: {}, ref: ForwardedRef<ActaPreviewRef>) => {
  const [open, setOpen] = useState(false);
  const [template, setTemplate] = useState<string>("");
  const [infraccionId, setInfraccionId] = useState<string>("");
  const [titularId, setTitularId] = useState<number>();
  const [infraccionEstado, setInfraccionEstado] = useState<string>("");
  const [configuracionProduccionId, setConfiguracionProduccionId] =
    useState<string>("");

  useImperativeHandle(ref, () => ({
    setOpen,
    setInfraccionId,
    setConfiguracionProduccionId,
    setInfraccionEstado,
    setTitularId
  }));

  const src = `${process.env.REACT_APP_API_URL}/LoteImpresion/VerActaMuestra()?Template=${template}&InfraccionId=${infraccionId}&ConfiguracionProduccionId=${configuracionProduccionId}`;

  const isPreviewAvailable =
  infraccionEstado !== "PENDIENTE" &&
  infraccionEstado !== "RENOMBRADA" &&
  infraccionEstado !== "CONSULTANDO" &&
  (titularId || configuracionProduccionId);

    return (
      <StyledModal
        footer={[]}
        title="Vista previa del acta"
        visible={open}
        onOk={() => setOpen(false)}
        onCancel={() => setOpen(false)}
      >
        {isPreviewAvailable ? (
          <StyledIframe
            title="Previsualización de acta de infracción"
            loading="lazy"
            key={`${template}-${infraccionId}-${configuracionProduccionId}`}
            src={src}
          />
        ) : (
          <ErrorMessage>Previsualización no disponible</ErrorMessage>
        )}
      </StyledModal>
    );
  };

export default forwardRef(ActaPreview) as (
  props: {} & { ref?: ForwardedRef<ActaPreviewRef> }
) => ReturnType<typeof ActaPreview>;
